import { render, staticRenderFns } from "./category2-search-group.vue?vue&type=template&id=990617ba&scoped=true&"
import script from "./category2-search-group.vue?vue&type=script&lang=js&"
export * from "./category2-search-group.vue?vue&type=script&lang=js&"
import style0 from "./category2-search-group.vue?vue&type=style&index=0&id=990617ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990617ba",
  null
  
)

export default component.exports